


export class RequestCorporateAccountContext {

    public routeTo: string[] = [];
    public oldDetails: any;
    public flowResult: string = ""
    constructor() {
    }
}